import { Box, Divider, IconButton, Modal, Skeleton, styled, Typography, useTheme } from '@mui/material';
import { useGetFlightIntegrationById } from '../../queries';
import { useSnackBar } from '@frontend/features/common/components/SnackBarContext';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { FormCreateOrEditFlightIntegration } from '../FormCreateOrEditFlightIntegration';

interface EditFlightIntegrationModalProps {
  open: boolean;
  onClose: () => void;
  flightIntegrationId: string | null;
}

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  background: theme.palette.background.paper,
  'box-shadow': 24,
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
}));

export const EditFlightIntegrationModal = ({ open, onClose, flightIntegrationId }: EditFlightIntegrationModalProps) => {
  const { data, isLoading, error, isError } = useGetFlightIntegrationById(flightIntegrationId ?? '');
  const theme = useTheme();
  const { addToast } = useSnackBar();
  const { t } = useTranslation();
  useEffect(() => {
    if (isError && error) {
      addToast({
        message: t('flightIntegrations.edit.loadItemError'),
        color: 'error',
      });
    }
  }, [isError, error, addToast]);
  return (
    <Modal open={open} onClose={onClose} aria-labelledby={t('flightIntegrations.edit.title')}>
      <StyledBox display="flex" flexDirection="column" gap={theme.spacing(2)}>
        <Box display="flex" gap={theme.spacing(2)}>
          <Box flexGrow={1} display="flex" alignItems="center" gap={theme.spacing(1)}>
            <Typography id="edit-flight-integrations-modal-title" variant="h6" component="h2">
              {t('flightIntegrations.edit.title')}
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon color="primary" />
          </IconButton>
        </Box>
        <Divider />
        {isLoading && <Skeleton height={theme.spacing(10)} variant="rounded" animation="wave" />}
        {data && <FormCreateOrEditFlightIntegration onClose={onClose} integrationToEdit={data} />}
      </StyledBox>
    </Modal>
  );
};
